import { X } from 'lucide-react';
import { useState } from 'react';
import LinkExpiryModal from './LinkExpiryModal';

const InviteModal = ({ 
  isOpen, 
  onClose, 
  emails, 
  testType, 
  onSend 
}) => {
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [showExpiryModal, setShowExpiryModal] = useState(false);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedCandidates(emails.map(email => email.id));
    } else {
      setSelectedCandidates([]);
    }
  };

  const handleSelect = (id) => {
    setSelectedCandidates(prev => {
      if (prev.includes(id)) {
        return prev.filter(candidateId => candidateId !== id);
      }
      return [...prev, id];
    });
  };

  const handleSend = () => {
    const selectedEmails = emails.filter(email => selectedCandidates.includes(email.id));
    setShowExpiryModal(true);
  };

  const handleExpiryConfirm = (expiryDate) => {
    const selectedEmails = emails.filter(email => selectedCandidates.includes(email.id));
    onSend(selectedEmails, expiryDate);
    setShowExpiryModal(false);
    onClose();
  };

  console.log('InviteModal render:', { isOpen, emails });

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg w-3/4 max-h-[80vh] overflow-hidden">
          <div className="p-4 border-b flex justify-between items-center">
            <h2 className="text-xl font-semibold">Send Pre-screening Invites</h2>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
              <X className="w-6 h-6" />
            </button>
          </div>

          <div className="p-4">
            <div className="mb-4">
              <div className="flex justify-between items-center mb-2">
                <h3 className="font-medium">Candidates ({emails.length})</h3>
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={selectedCandidates.length === emails.length}
                    onChange={handleSelectAll}
                    className="rounded border-gray-300 text-orange-500 focus:ring-orange-500"
                  />
                  <span className="ml-2">Select All</span>
                </label>
              </div>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Select
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Name
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Email
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {emails.map(({ email, name, id }, index) => (
                      <tr key={id || index}>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <input
                            type="checkbox"
                            checked={selectedCandidates.includes(id)}
                            onChange={() => handleSelect(id)}
                            className="rounded border-gray-300 text-orange-500 focus:ring-orange-500"
                          />
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span className="font-medium">{name}</span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-gray-500">
                          {email}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="flex justify-end gap-2 mt-4">
              <button
                onClick={onClose}
                className="px-4 py-2 text-gray-600 hover:text-gray-800"
              >
                Cancel
              </button>
              <button
                onClick={handleSend}
                disabled={selectedCandidates.length === 0}
                className="px-4 py-2 bg-orange-500 text-white rounded hover:bg-orange-600 disabled:opacity-50"
              >
                Send Invites ({selectedCandidates.length})
              </button>
            </div>
          </div>
        </div>
      </div>

      <LinkExpiryModal
        isOpen={showExpiryModal}
        onClose={() => setShowExpiryModal(false)}
        onConfirm={handleExpiryConfirm}
        testType={testType}
      />
    </>
  );
};

export default InviteModal; 